const LOCATION_ID = '224723'

class DeliveryInfo extends HTMLElement {
  constructor() {
    super();

    this.label = this.querySelector('[data-label]');

    // Fetch delivery slots
    window.ZapietEvent.listen('widget_loaded', () => {
      window.Zapiet.Helpers.getSlots(
        'delivery', 
        LOCATION_ID, 
        '', 
        this.updateAvailability.bind(this)
      );
    });
  }

  getDeliveryInfo(minDate) {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    // Reset time components to ensure only date comparison
    today.setHours(0, 0, 0, 0);
    tomorrow.setHours(0, 0, 0, 0);
    minDate.setHours(0, 0, 0, 0);

    if (minDate.getTime() === today.getTime()) {
        return "Today delivery available";
    } else if (minDate.getTime() === tomorrow.getTime()) {
        return "Tomorrow delivery available";
    } 

    return null;
  }

  updateAvailability(data) {
    const minDate = new Date(data.minDate);
    const deliveryInfo = this.getDeliveryInfo(minDate);

    if (deliveryInfo) {
      this.classList.remove('hidden');
      this.label.textContent = deliveryInfo;
    }
  }
}

customElements.define('delivery-info', DeliveryInfo);